import { useUser } from '@/context/userContext';
import { Navigate, Outlet } from 'react-router';
import { getSelectBillingPlanPath } from '@/bundle/Auth/AdminOnboardingFlow/SelectBillingPlanPage/path';
import { hasBillingSubscription, isStandardPlanType } from '@/helpers/billingHelpers';

export const SubscriptionRequiredProtectedRoute = () => {
  const { user, isMasterAdminRole } = useUser();
  const hasSubscription = hasBillingSubscription(user);
  const isStandardPlan = isStandardPlanType(user);

  if (isMasterAdminRole && isStandardPlan && !hasSubscription) {
    return <Navigate to={getSelectBillingPlanPath()} replace />;
  }

  return <Outlet />;
};
